import * as React from "react"
import * as styles from "./styles.module.scss"
import cls from "classnames"
import {IdHeading} from "components/organisms/IdHeading";

type QuestionProps = {
    questionTxt?: string
    children: React.ReactNode
    underline?: boolean,
    defaultOpen?: boolean
}
type CardProps = {
    title?: string
    items: QuestionProps[],
    underline?: boolean,
    className?: string
}

export type FaqProps = {
    stickyMenu?: boolean
    items: CardProps[],
    className?: string,
    faqClassName?: string,
    title?: string
    underline?: boolean
    scrollable?: boolean
    childrenClassNames?: {
        card?: string
    }
}

export const Question = (props: QuestionProps) => {
    const {questionTxt, children, underline, defaultOpen = false } = props

    const [isClosed, setisClosed] = React.useState(!defaultOpen)

    const toogleQuestion = () => {
        isClosed ? setisClosed(false) : setisClosed(true)
    }

    return (
        questionTxt ?
            <div itemProp="mainEntity" itemScope={true} itemType="https://schema.org/Question"
                 className={cls(styles.question_card, underline && styles.underline)}>
                <div itemProp="name" onClick={toogleQuestion}>
                    <IdHeading headingLevel={5} className={styles.question_title}>
                        {questionTxt}
                    </IdHeading>
                </div>
                <div>
                    <button
                        onClick={toogleQuestion}
                        className={cls(
                            styles.icon,
                            isClosed ? styles.expand : styles.collapse
                        )}
                    ></button>
                    <div itemProp="acceptedAnswer" itemScope={true} itemType="https://schema.org/Answer" className={cls(isClosed ? styles.hidden : styles.visible)}>
                        <div itemProp="text">
                            {children}
                        </div>
                    </div>
                </div>
            </div> :
            <div className={cls(styles.question_card, underline && styles.underline)}>
                {children}
            </div>
    )
}
export const FAQCard = React.forwardRef(
    (props: CardProps, ref: React.Ref<HTMLDivElement>) => {
        const {title: cardTitle, items: questions, underline, className} = props
        return (
            <div className={cls(className, styles.card)} ref={ref}>
                {cardTitle && (<IdHeading headingLevel={4} className={styles.card_title}>{cardTitle}</IdHeading>)}
                {questions.map((item, ind) => {
                    return (
                        <Question
                            questionTxt={item.questionTxt}
                            key={item.questionTxt + ind}
                            underline={underline}
                            defaultOpen={ind === 0}
                        >
                            {item.children}
                        </Question>
                    )
                })}
            </div>
        )
    }
)

export const FAQ = (props: FaqProps) => {
    const {items: cards, scrollable = true, underline = true, childrenClassNames, stickyMenu=false} = props

    const refs = React.useRef<Array<HTMLDivElement | null>>([])
    let refCard: HTMLDivElement | null;
    const [activeIndex, setActiveIndex] = React.useState<number | null>(null)
    const scrollTo = (refInd: number) => {
        let offset = 0;
        const scrollableDiv = refCard;

        if (scrollableDiv) {
            scrollableDiv.scrollTop = 0;
            let innerOffset = refs.current[refInd]?.getBoundingClientRect().top
            if (typeof innerOffset === "number") {
                let scrollY = innerOffset - scrollableDiv.getBoundingClientRect().top
                if (scrollY < 0) scrollY = 0
                scrollableDiv.scrollTop = scrollY;
            }

            offset = refs.current[refInd]?.getBoundingClientRect().top;
            let headerOffset = 130;
            let offsetPosition = offset + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }

    React.useEffect(() => {
        const handleScroll = () => {
            const viewportCenter = window.innerHeight / 2;
            refs.current.forEach((ref, index) => {
                if (!ref) return;
                const rect = ref.getBoundingClientRect();
                if (rect.top <= viewportCenter && rect.bottom >= viewportCenter) {
                    setActiveIndex(index);
                }
            });
        };
        window.addEventListener("scroll", handleScroll);
        const card = refCard;
        if (card) {
            card.addEventListener("scroll", handleScroll);
        }
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (card) card.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        // <div className="bs-flex-container">
        <section itemScope={true} itemType="https://schema.org/FAQPage" className={props.className ? props.className : "bg-light-gray"}>
            <div className={cls(props.faqClassName, styles.faq, 'bs-flex-container l')}>
                <div className={styles.left_column}>
                    <IdHeading headingLevel={2} className={styles.title}>{props.title ? props.title : "Frequently asked questions"}</IdHeading>
                    <nav className={cls(styles.navigation, stickyMenu ? styles.sticky : '')}>
                        <ul className={styles.links}>
                            {cards.map((card, index) => {
                                if (card.title) {
                                    return (
                                        <li key={card.title + `${index}`} className={`${styles.link} ${activeIndex === index ? styles.active : ''}`}>
                                            <a onClick={() => scrollTo(index)}>{card.title}</a>
                                        </li>
                                    )
                                }
                            })}
                        </ul>
                    </nav>
                </div>
                <div className={cls(styles.right_column, scrollable ? styles.scrollable : "")} ref={el => refCard = el}>
                    {cards.map(({title, items}, index) => {
                        return (
                            <FAQCard
                                className={childrenClassNames?.card}
                                key={title + `${index}`}
                                ref={el => {
                                    refs.current[index] = el
                                }}
                                title={title}
                                items={items}
                                underline={underline}
                            />
                        )
                    })}
                </div>
            </div>
        </section>
    )
}
